(() => {
  const key = 'lala_internal_traffic';
  const allowed = new Set(['codex_qa', 'owner_qa', 'simgym_qa']);
  const params = new URLSearchParams(window.location.search);
  const requested = params.get('lala_internal');

  if (requested === 'clear') localStorage.removeItem(key);
  else if (allowed.has(requested)) localStorage.setItem(key, requested);

  const source = localStorage.getItem(key);
  if (!allowed.has(source)) return;

  window.__lalaInternalTraffic = { type: 'internal', source };
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({ event: 'lala_internal_qa', traffic_type: 'internal', lala_qa_source: source });

  window.clarity = window.clarity || function () { (window.clarity.q = window.clarity.q || []).push(arguments); };
  window.clarity('set', 'traffic_type', 'internal');
  window.clarity('set', 'lala_qa_source', source);
})();
